var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "flex w-full overflow-y-auto overflow-x-hidden",
        attrs: { id: "form-activity", autocomplete: "off" }
      },
      [
        _c("div", { staticClass: "w-full pr-20" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
              _vm.$v.input.artwork.$dirty && !_vm.$v.input.artwork.required
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Please select song artwork.")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isFileLarge
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Please using image lower than 1MB")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.input.artwork
                ? _c("input", {
                    staticClass:
                      "block border border-grey-light w-full p-3 rounded",
                    attrs: {
                      type: "file",
                      name: "profile_picture",
                      accept: "image/*"
                    },
                    on: { change: _vm.onFileChange }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.input.artwork
                ? _c("div", { staticClass: "tooltip" }, [
                    _vm.input.artwork
                      ? _c("img", {
                          staticStyle: { width: "150px" },
                          attrs: { src: _vm.input.artwork },
                          on: { click: _vm.changeImage }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "hint-tooltip" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "times-circle"], size: "2x" },
                          on: { click: _vm.changeImage }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "text-xs" }, [
                _vm._v("Minimum 900x900, Maximum 1MB")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
              _vm.$v.input.fileMusicPreview.$dirty &&
              !_vm.$v.input.fileMusicPreview.required
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Please select file song.")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isFileMusicNotMP3
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Please ensure the file is in .mp3 format")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.input.fileMusicPreview
                ? _c("input", {
                    attrs: { type: "file", name: "music", accept: "audio/mp3" },
                    on: { change: _vm.onFileMusicChange }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.input.fileMusicPreview
                ? _c("div", { staticClass: "flex" }, [
                    _c(
                      "audio",
                      { ref: "audioFile", attrs: { controls: "controls" } },
                      [
                        _c("source", {
                          attrs: {
                            src: _vm.input.fileMusicPreview,
                            type: "audio/mp3"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pl-5 pt-2 cursor-pointer" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "times"], size: "2x" },
                          on: { click: _vm.changeFileMusic }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
              _vm.$v.input.musicName.$dirty && !_vm.$v.input.musicName.required
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Please fill Song Name.")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$v.input.musicName.$dirty && !_vm.$v.input.musicName.maxLength
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Max length Song name is 100 character.")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.musicName,
                    expression: "input.musicName"
                  }
                ],
                staticClass:
                  "appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-1 leading-tight focus:outline-none focus:bg-white",
                attrs: {
                  id: "grid-name-song",
                  type: "text",
                  placeholder: "Song Name",
                  autocomplete: "off"
                },
                domProps: { value: _vm.input.musicName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.input, "musicName", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
            _vm._m(5),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0 relative" },
              [
                _vm.$v.input.musicDescription.$dirty &&
                !_vm.$v.input.musicDescription.required
                  ? _c(
                      "p",
                      { staticClass: "text-red-500 text-xs italic text-left" },
                      [_vm._v("Please fill the Description.")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$v.input.musicDescription.$dirty &&
                !_vm.$v.input.musicDescription.maxLength
                  ? _c(
                      "p",
                      { staticClass: "text-red-500 text-xs italic text-left" },
                      [_vm._v("Max length description song is 1000 character")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.input.musicDescription,
                      expression: "input.musicDescription"
                    }
                  ],
                  staticClass:
                    "appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-1 leading-tight focus:outline-none focus:bg-white",
                  attrs: {
                    rows: "7",
                    id: "grid-name-music",
                    type: "text",
                    placeholder: "Description Song",
                    autocomplete: "off"
                  },
                  domProps: { value: _vm.input.musicDescription },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.input,
                        "musicDescription",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "absolute right-0 text-xs",
                    staticStyle: { bottom: "15px", right: "40px" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.input.musicDescription.length) +
                        "/" +
                        _vm._s(_vm.maxLengthDesc)
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
              _vm.$v.input.year.$dirty && !_vm.$v.input.year.required
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Please fill Year Song.")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$v.input.year.$dirty && !_vm.$v.input.year.numeric
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Please fill Year Song with number.")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$v.input.year.$dirty && !_vm.$v.input.year.maxLength
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Max length Year Song is 4 character.")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.year,
                    expression: "input.year"
                  }
                ],
                staticClass:
                  "appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-1 leading-tight focus:outline-none focus:bg-white",
                attrs: {
                  id: "grid-year-music",
                  type: "text",
                  placeholder: "ex. 2020",
                  autocomplete: "off"
                },
                domProps: { value: _vm.input.year },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.input, "year", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
              _vm.$v.input.genre.$dirty && !_vm.$v.input.genre.required
                ? _c(
                    "p",
                    { staticClass: "text-red-500 text-xs italic text-left" },
                    [_vm._v("Please select song category.")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.input.genre,
                      expression: "input.genre"
                    }
                  ],
                  staticClass:
                    "block border border-grey-light w-full p-3 rounded mb-4",
                  attrs: { id: "grid-genre-song", type: "text", name: "genre" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.input,
                        "genre",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [_vm._v("Select Song Category")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.listGenreSong, function(item, key) {
                    return _c(
                      "option",
                      {
                        key: key,
                        attrs: { "v-text": item.name },
                        domProps: { value: item.id }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.name) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-4" }, [
            _vm._m(8),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" },
              [
                _vm.$v.input.language.$dirty &&
                !_vm.$v.input.language.required &&
                _vm.isArtist
                  ? _c(
                      "p",
                      { staticClass: "text-red-500 text-xs italic text-left" },
                      [_vm._v("Please choose language.")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticClass: "w-full",
                    attrs: { filterable: "", placeholder: "Select Language" },
                    model: {
                      value: _vm.input.language,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "language", $$v)
                      },
                      expression: "input.language"
                    }
                  },
                  _vm._l(_vm.dataLanguages, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
            _vm._m(9),
            _vm._v(" "),
            _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
              _c(
                "label",
                {
                  staticClass: "flex items-center cursor-pointer",
                  attrs: { for: "toogleCopyRight" }
                },
                [
                  _c("div", { staticClass: "relative" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.input.copyRight,
                          expression: "input.copyRight"
                        }
                      ],
                      staticClass: "hidden",
                      attrs: { id: "toogleCopyRight", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.input.copyRight)
                          ? _vm._i(_vm.input.copyRight, null) > -1
                          : _vm.input.copyRight
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.input.copyRight,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.input,
                                  "copyRight",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.input,
                                  "copyRight",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.input, "copyRight", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-3 text-gray-700 font-medium" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.input.copyRight ? "Yes" : "No") +
                        "\n            "
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.input.copyRight
            ? _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
                  _vm.$v.input.copyRightFile.$dirty &&
                  !_vm.$v.input.copyRightFile.required
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Please select copyright file.")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.input.copyRightFile
                    ? _c("input", {
                        staticClass:
                          "block border border-grey-light w-full p-3 rounded",
                        attrs: {
                          type: "file",
                          name: "copyright_file",
                          accept:
                            "image/*,application/pdf,application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint"
                        },
                        on: { change: _vm.onFileChangeCopyRight }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.input.copyRightFile
                    ? _c("div", { staticClass: "flex" }, [
                        _c(
                          "span",
                          { staticClass: "mr-2 text-gray-700 font-medium" },
                          [_vm._v(_vm._s(_vm.copyRightFileName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          { on: { click: _vm.changeCopyRight } },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "times-circle"] }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(11),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
            _vm._m(12),
            _vm._v(" "),
            _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
              _c(
                "label",
                {
                  staticClass: "flex items-center cursor-pointer",
                  attrs: { for: "toogleSubs" }
                },
                [
                  _c("div", { staticClass: "relative" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.input.isSubscription,
                          expression: "input.isSubscription"
                        }
                      ],
                      staticClass: "hidden",
                      attrs: { id: "toogleSubs", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.input.isSubscription)
                          ? _vm._i(_vm.input.isSubscription, null) > -1
                          : _vm.input.isSubscription
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.input.isSubscription,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.input,
                                  "isSubscription",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.input,
                                  "isSubscription",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.input, "isSubscription", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-3 text-gray-700 font-medium" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.input.isSubscription ? "On" : "Off") +
                        "\n            "
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
            _vm._m(13),
            _vm._v(" "),
            _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
              _c(
                "label",
                {
                  staticClass: "flex items-center cursor-pointer",
                  attrs: { for: "tooglePaid" }
                },
                [
                  _c("div", { staticClass: "relative" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.input.isPaid,
                          expression: "input.isPaid"
                        }
                      ],
                      staticClass: "hidden",
                      attrs: { id: "tooglePaid", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.input.isPaid)
                          ? _vm._i(_vm.input.isPaid, null) > -1
                          : _vm.input.isPaid
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.input.isPaid,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.input, "isPaid", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.input,
                                  "isPaid",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.input, "isPaid", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-3 text-gray-700 font-medium" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.input.isPaid ? "Yes" : "No") +
                        "\n            "
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.input.isPaid
            ? _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
                _vm._m(14),
                _vm._v(" "),
                _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" }, [
                  _vm.$v.input.price.$dirty && !_vm.$v.input.price.required
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Price is required.")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.input.price.$dirty && !_vm.$v.input.price.decimal
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Price must be a number.")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("\n            $ "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.input.price,
                          expression: "input.price"
                        }
                      ],
                      staticClass:
                        "appearance-none bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white",
                      attrs: {
                        id: "grid-price-music",
                        type: "text",
                        placeholder: "ex. 5",
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.input.price },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.input, "price", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(
                      "\n                = " +
                        _vm._s(_vm.creditPrice) +
                        " Credits"
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.input.isPaid && _vm.input.price != 0
            ? _c("div", { staticClass: "flex flex-wrap -mx-3 mb-6" }, [
                _vm._m(15),
                _vm._v(" "),
                _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-6 md:mb-0" }, [
                  _vm._v(
                    "\n          $ " +
                      _vm._s(_vm.priceMusicVerse) +
                      "\n        "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.input.isPaid && _vm.input.price != 0
            ? _c("div", { staticClass: "flex flex-wrap -mx-3 mb-6" }, [
                _vm._m(16),
                _vm._v(" "),
                _c("div", { staticClass: "w-3/4 md:w-3/4 px-5 mb-6 md:mb-0" }, [
                  _vm._v(
                    "\n          $ " +
                      _vm._s(_vm.priceArtistMusicVerse) +
                      "\n        "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.progressbar !== 0
            ? _c("div", { staticClass: "flex flex-wrap -mx-3 mb-3" }, [
                _c("div", { staticClass: "shadow w-full bg-grey mt-2" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "bg-teal-500 text-xs leading-none py-1 text-center text-white",
                      style: "width: " + _vm.progressbar + "%;"
                    },
                    [_vm._v(_vm._s(_vm.progressbar) + "%")]
                  )
                ])
              ])
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1" }, [
      _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
        _c(
          "label",
          {
            staticClass:
              "block uppercase tracking-wide text-gray-700  font-bold mb-2"
          },
          [_vm._v("\n            Artworks and File\n          ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        },
        [_vm._v("\n            Artwork\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        },
        [_vm._v("\n            File\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1 mt-8" }, [
      _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
        _c(
          "label",
          {
            staticClass:
              "block uppercase tracking-wide text-gray-700 font-bold mb-2"
          },
          [_vm._v("\n            Metadata\n          ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
          attrs: { for: "grid-name-song" }
        },
        [_vm._v("\n            Name\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
          attrs: { for: "grid-name-music" }
        },
        [_vm._v("\n            Description\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
          attrs: { for: "grid-year-music" }
        },
        [_vm._v("\n            Year\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
          attrs: { for: "grid-genre-song" }
        },
        [_vm._v("\n            Category\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
          attrs: { for: "grid-genre-song" }
        },
        [_vm._v("\n            Language\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        },
        [_vm._v("\n            Copyright\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        },
        [_vm._v("\n            Upload Copyright\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-wrap -mx-3 mb-1 mt-8" }, [
      _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
        _c(
          "label",
          {
            staticClass:
              "block uppercase tracking-wide text-gray-700 font-bold mb-2"
          },
          [_vm._v("\n            Monetization\n          ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        },
        [
          _vm._v("\n            Subscription\n            "),
          _c("br"),
          _vm._v(" "),
          _c("small", { staticClass: "text-gray-700 font-medium" }, [
            _vm._v("Turn on to earn revenue per song stream.")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("small", { staticClass: "text-gray-700 font-medium" }, [
            _vm._v("Turn off if users can listen for free")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        },
        [
          _vm._v("\n            Sell song\n            "),
          _c("br"),
          _vm._v(" "),
          _c("small", { staticClass: "text-gray-700 font-medium" }, [
            _vm._v("Allow user to buy this song? ")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-1 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
          attrs: { for: "grid-price-music" }
        },
        [_vm._v("\n            Song Price (USD)\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-6 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
          attrs: { for: "grid-price-music" }
        },
        [_vm._v("\n            MusicVerse Cut\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/4 md:w-1/4 px-3 mb-6 md:mb-0" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
          attrs: { for: "grid-price-music" }
        },
        [_vm._v("\n            Artist Cut\n          ")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a01b9a4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b9a4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/contents/AddSong.vue
// module id = null
// module chunks = 